/**
 * components/settings/SettingsSection.tsx
 *
 * Wrapper deux colonnes pour les sections de la page Paramètres.
 * Patron inspiré de GitHub, Stripe et Linear : titre + description à gauche
 * (lg:col-span-1), contenu (card) à droite (lg:col-span-2).
 * Repasse en colonne unique sur mobile (titre/description au-dessus, card en dessous).
 * Variante "danger" pour la section de suppression de compte (titre en rouge).
 */

import { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface SettingsSectionProps {
  title: string;
  description: string;
  children: ReactNode;
  variant?: 'default' | 'danger';
}

export default function SettingsSection({
  title,
  description,
  children,
  variant = 'default',
}: SettingsSectionProps) {
  const isDanger = variant === 'danger';

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
      <div className="lg:col-span-1">
        {isDanger ? (
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle className="w-4 h-4 text-error-600 flex-shrink-0" />
            <h2 className="text-base font-semibold text-error-700">{title}</h2>
          </div>
        ) : (
          <h2 className="text-base font-semibold text-neutral-900 mb-2">{title}</h2>
        )}
        <p className="text-sm text-neutral-500 leading-relaxed">{description}</p>
      </div>

      <div className="lg:col-span-2">{children}</div>
    </div>
  );
}
